import apiClient from './client';

export interface Subscription {
    id: number;
    user_id: number;
    plan: 'free' | 'pro';
    status: 'active' | 'trialing' | 'past_due' | 'canceled' | 'inactive';
    provider: 'web' | 'apple' | 'google' | '';
    current_period_end?: string;
    created_at: string;
    updated_at: string;
}

const subscriptionService = {
    getSubscription: async (): Promise<Subscription> => {
        const { data } = await apiClient.get<Subscription>('/api/v1/subscription');
        return data;
    },
};

export default subscriptionService;
